/* modules */
const globals = require('./common/globals.js');

module.exports = (function () {
  jQuery(($) => {
    if ($('body').length) {
      globals.init($);
    }

    if ($('.category-products').length) {
      require('./components/our-products-expand').init($);
    }

    if ($(".jump-menu").length) {
      require("./components/jump-menu").init($);
    }
    
    if ($("#product-zoom").length) {
      require("./components/product-image-zoom").init($);
    }
    
    if ($("#product-info").length) {
      require("./components/single-products-expand").init($);
    }

    if ($("#prep-info").length) {
      require("./components/single-products-prep-expand").init($);
    }

    if ($('.owl-carousel').length) {
      require("./components/single-products-carousel").init($);
    }

    if ($("form.wpcf7-form").length) {
      require("./components/form").init($);
    }

    if ($("#video-showcase").length) {
      require("./components/home-video").init($);
    }
    if ($("#video-showcase").length) {
      require("./components/home-video").init($);
    }
    if ($(".page-template-tpl-our-recipe").length) {
      require("./components/recipe").init($);
    }
    if ($(".single-recipes").length) {
      require("./components/recipe").init($);
    }
  });
}());